import React from 'react'
import PropTypes from 'prop-types'
import { NavLink as RouteNavLink } from 'react-router-dom'
import { NavItem, NavLink } from 'shards-react'

const mountLinkToRedirect = (pageNumber, item) => {
    if (item.title === 'MINIAPPS') {
        return pageNumber ? item.to + pageNumber : item.to + 1
    }

    return item.to
}

const SidebarNavItem = ({ item, pageNumber }) => (
    <NavItem>
        <NavLink tag={props => <RouteNavLink {...props} />} to={mountLinkToRedirect(pageNumber, item)}>
            {item.htmlBefore && (
                <div
                    className="d-inline-block item-icon-wrapper"
                    dangerouslySetInnerHTML={{ __html: item.htmlBefore }}
                />
            )}
            {item.title && <span>{item.title}</span>}
            {item.htmlAfter && (
                <div
                    className="d-inline-block item-icon-wrapper"
                    dangerouslySetInnerHTML={{ __html: item.htmlAfter }}
                />
            )}
        </NavLink>
    </NavItem>
)

SidebarNavItem.propTypes = {
    /**
     * The item object.
     */
    item: PropTypes.object,
    pageNumber: PropTypes.string,
}

export default SidebarNavItem
